import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);

export namespace btnTabsSlider {

	let setupSlider = () => {
		let productTabSlider = document.querySelectorAll('.js-product-tab-links');

		productTabSlider.forEach((slider, index) => {
			slider.classList.add(`product-tab-links__swiper--${index}`);
			const swiper = new Swiper(`.product-tab-links__swiper--${index}`, {
				spaceBetween: 0,
				initialSlide: 0,
				breakpoints: {
					0: {
						slidesPerView: 1,
					},
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						watchSlidesProgress: false,
						slideToClickedSlide: true
					},
					992: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 10,
						watchSlidesProgress: false,
						slideToClickedSlide: true
					}
				},

				navigation: {
					nextEl: `.swiper-nav-button-next`,
					prevEl: `.swiper-nav-button-prev`,
				},
				on: {
					slideChange: function () {
						// If a programmatic navigation has set this flag, consume it and do not auto-click.
						if ((window as any).productTabSkipNextClick) {
							(window as any).productTabSkipNextClick = false;
							return;
						}

						const activeSlide = swiper.slides[swiper.activeIndex];
						const anchor = activeSlide && activeSlide.querySelector('a');
						if (anchor) {
							anchor.click(); // Programmatically trigger click for user-driven slide changes
						}
					}
				}
			});
		});
	}

	export const init = () => {
		setupSlider();
	}
}

document.addEventListener('DOMContentLoaded', btnTabsSlider.init);
